import { render, staticRenderFns } from "./salonList.vue?vue&type=template&id=3e66f1ca&scoped=true&"
import script from "./salonList.vue?vue&type=script&lang=js&"
export * from "./salonList.vue?vue&type=script&lang=js&"
import style0 from "./salonList.vue?vue&type=style&index=0&id=3e66f1ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66f1ca",
  null
  
)

export default component.exports